export function lazyLoadImage() {
  // 使用 IntersectionObserver 實現更好的 lazy loading
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.getAttribute('data-src');
          img.style.display = 'block';
          img.classList.remove('lazy-load-image');
          imageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px' // 提前 50px 開始載入
    });

    const lazyLoadImages = document.querySelectorAll('.lazy-load-image');
    lazyLoadImages.forEach(function(img) {
      imageObserver.observe(img);
    });
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    const lazyLoadImages = document.querySelectorAll('.lazy-load-image');
    lazyLoadImages.forEach(function(img) {
      img.src = img.getAttribute('data-src');
      img.style.display = 'block';
    });
  }
}
